import React, { useState } from "react";
import PerfilCursos from "./components/PerfilCursos";
import ModalDetalleCurso from "./components/ModalDetalleCurso";
import FiltroCursoPerfil from "./components/FiltroCursoPerfil/FiltroCursoPerfil";

export default function InfoCursos() {
  const [showModal, setShowModal] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("TODOS");

  // Se recibe el id del curso clickeado y se muestra el modal
  const handleCardClick = (courseId) => {
    setSelectedCourseId(courseId);
    setShowModal(true);
  };

  // Función para cerrar el modal y limpiar el id seleccionado
  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div data-figma-id="1620:14310" className="perfil-info-2">
      <p data-figma-id="1620:14311" className="info-1-curso-titulo-2-2">
        Cursos
      </p>
      <FiltroCursoPerfil
        filterText={filterText}
        setFilterText={setFilterText}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        onFilterClick={() => setShowModal(false)}  
      />
      <div className="frame-290159">
        {showModal ? (
          <ModalDetalleCurso
            onClose={handleCloseModal}
            courseId={selectedCourseId}
          />
        ) : (
          <PerfilCursos
            onCardClick={handleCardClick}
            filterText={filterText}
            selectedCategory={selectedCategory}
          />
        )}
      </div>
    </div>
  );
}
